import { CheckIcon, InfoIcon, WarningIcon } from "../../icons";
import { forwardRef, useMemo } from "react";
import { Content } from "../../placeholders";
import { CrossButton } from "../../button";
import { augmentElement, cssModule, isNil, mergeProps, useMergedRefs, useSlots } from "../../shared";
import { StyleProvider } from "../../styling";
import { Text } from "../../typography";
import { Transition } from "../../transition";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "div";
const MessageContent = /*#__PURE__*/forwardRef(({
  children,
  ...rest
}, ref) => {
  return /*#__PURE__*/_jsx(Text, { ...rest,
    ref: ref,
    children: /*#__PURE__*/_jsx(StyleProvider, {
      value: {
        heading: {
          className: "o-ui-message-title",
          size: "2xs"
        },
        "html-a": {
          color: "inherit"
        },
        link: {
          color: "inherit"
        }
      },
      children: children
    })
  });
});
const Role = {
  informative: "status",
  negative: "alert",
  positive: "status",
  warning: "alert"
};
const Icon = {
  informative: /*#__PURE__*/_jsx(InfoIcon, {}),
  negative: /*#__PURE__*/_jsx(InfoIcon, {}),
  positive: /*#__PURE__*/_jsx(CheckIcon, {}),
  warning: /*#__PURE__*/_jsx(WarningIcon, {})
};
export function InnerMessage({
  as = DefaultElement,
  children,
  forwardedRef,
  onDismiss,
  role: roleProp,
  show = true,
  variant = "informative",
  ...rest
}) {
  var _ref;

  const ref = useMergedRefs(forwardedRef);
  const {
    button,
    content
  } = useSlots(children, useMemo(() => ({
    _: {
      defaultWrapper: Content
    },
    button: {
      className: "o-ui-message-action",
      condensed: true,
      inherit: true,
      size: "sm",
      variant: "tertiary"
    },
    content: {
      as: MessageContent,
      className: "o-ui-message-content"
    }
  }), []));
  const iconMarkup = augmentElement(Icon[variant], {
    className: "o-ui-message-icon"
  });

  const dismissMarkup = !isNil(onDismiss) && /*#__PURE__*/_jsx(CrossButton, {
    "aria-label": "Dismiss",
    className: "o-ui-message-dismiss",
    color: "inherit",
    onClick: onDismiss,
    size: "sm"
  });

  return /*#__PURE__*/_jsxs(Transition, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-message", variant),
      enter: "o-ui-fade-in",
      leave: "o-ui-fade-out",
      ref,
      role: (_ref = roleProp !== null && roleProp !== void 0 ? roleProp : Role[variant]) !== null && _ref !== void 0 ? _ref : "alert",
      show
    }),
    children: [iconMarkup, content, button, dismissMarkup]
  });
}
InnerMessage.defaultElement = DefaultElement;
export const Message = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerMessage, { ...props,
  forwardedRef: ref
}));